
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".swiper-info").forEach((element) => {
        new Swiper(element, {
            loop: true,
            effect: 'fade',
            speed: 1000,
            slidesPerView: 1,
            navigation: {
                nextEl: element.querySelector(".swiper-button-next"),
                prevEl: element.querySelector(".swiper-button-prev"),
            },
            breakpoints: {
                990: {
                    slidesPerView: 1,
                }
            },
        });
    });

    document.querySelectorAll(".swiper-concept").forEach((element) => {
        new Swiper(element, {
            loop: true,
            speed: 1000,
            slidesPerView: 1,
            navigation: {
                nextEl: element.querySelector(".swiper-button-next"),
                prevEl: element.querySelector(".swiper-button-prev"),
            },
            breakpoints: {
                750: {
                    slidesPerView: 2.7,
                    spaceBetween: 30,
                }
            },
        });
    });
});
